<script>
export default {
  props: {
    initalTab: String,
  },
  data() {
    return {
      currentTabName: this.initalTab,
    };
  },
  methods: {
    setCurrentTab(tabName) {
      this.currentTabName = tabName;
    },
  },
};
</script>

<template>
  <slot :currentTabName="currentTabName" :setCurrentTab="setCurrentTab" />
  <slot :name="currentTabName" />
</template>
